(function() {
  'use strict';
  var $ = avm.require('jquery'),
    cookieStorage = avm.require('avast.storage.cookieStorage'),
    countdownTimer,
    $buenFinpopup = $('.js-buenFinPopup'),
    $copyToClipboardButton = $buenFinpopup.find('.js-btn-buenfin'),
    $tooltip = $buenFinpopup.find('.js-tooltip'),
    $close = $buenFinpopup.find('.js-popup-close'),
    $counterDays = $buenFinpopup.find('.js-counter-days'),
    $counterHours = $buenFinpopup.find('.js-counter-hours'),
    $counterMinutes = $buenFinpopup.find('.js-counter-minutes'),
    $counterSeconds = $buenFinpopup.find('.js-counter-seconds'),
    closedCookieCount = cookieStorage.getItem('closedCookieCount') ? parseInt(cookieStorage.getItem('closedCookieCount')) : 0,
    $copyAllias = $buenFinpopup.find('.js-allias-buenfin'),
    days,
    hoursLeft,
    hours,
    minutesLeft,
    minutes,
    remainingSeconds,
    seconds = calculateTimeToExpire(),
    dateToExpire,
    cookieTimeExpire;


  // Check if time left to end of campaign && Check if timer closed twice
  if (seconds > 0 && shouldBePopupOpened()) {
    // init popup
    initPopup();
  }

  function timer() {
    days = Math.floor(seconds / 24 / 60 / 60);
    hoursLeft = Math.floor(seconds - days * 86400);
    hours = Math.floor(hoursLeft / 3600);
    minutesLeft = Math.floor(hoursLeft - hours * 3600);
    minutes = Math.floor(minutesLeft / 60);
    remainingSeconds = Math.round(seconds % 60);

    $counterDays.text(pad(days));
    $counterHours.text(pad(hours));
    $counterMinutes.text(pad(minutes));
    $counterSeconds.text(pad(remainingSeconds));

    if (seconds === 0) {
      clearInterval(countdownTimer);
      $buenFinpopup.addClass('hide');
    } else {
      seconds--;
    }
  }

  // This adds 0 before number if number is lower than 10
  function pad(n) {
    return n < 10 ? '0' + n : n;
  }

  function calculateTimeToExpire() {
    var currentTime = new Date().getTime();

    dateToExpire = new Date('2021-06-01').getTime();
    cookieTimeExpire = new Date('Tue Jun 1 2021 00:00:01 GMT').toUTCString();

    return (dateToExpire - currentTime) / 1000; // convert to seconds
  }

  function initPopup() {
    countdownTimer = setInterval(timer, 1000);

    // This timeout prevents from displaying different time on counter before time is calculated
    setTimeout(function() {
      $buenFinpopup.removeClass('hide');
    }, 1000);

    $copyToClipboardButton.on('click', function() {
      //var $self = $(this);

      // Select and copy to clipboard and deselect
      $copyAllias[0].select();
      document.execCommand('copy');
      $copyAllias[0].blur();

      // Show tooltip
      $tooltip.addClass('visible');

      // Hide tooltip after 4 seconds
      setTimeout(function() {
        $tooltip.removeClass('visible');
      }, 2500);
    });

    // Close pop up by user
    $close.on('click', function() {
      $buenFinpopup.addClass('hidden');
      addCookie();
    });
  }

  function addCookie() {
    // iterate closed count
    var newCount = closedCookieCount + 1
    cookieStorage.setItem('closedCookieCount', newCount, cookieTimeExpire, '/', '.avast.com');
    cookieStorage.getItem('closedCookieCount')
  }

  function shouldBePopupOpened() {
    return closedCookieCount < 2;
  }
})();
